// extracted by mini-css-extract-plugin
module.exports = {"box":"TableComponent_box__2L3gK","table":"TableComponent_table__PllJc"};